export { default as eventmodel } from './eventmodel';



// WEBPACK FOOTER //
// ./src/models/index.js